import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { MessageSuccess, CustomIcon, Container, CustomButton } from './mixins'
import { SuccessProps } from '../../interface'
import { getCouponCode, resetCoupon } from '../../../../../../../store/coupon/actionsToDo'
import { AppStore } from '../../../../../../../store'
import { ValorizedCartState } from '../../../../../../../store/cart-v2/valorized/types'
import { postCartValorized } from '../../../../../../../store/cart-v2/valorized/actionsToDo'

export const CouponSuccess = ({ isInputVisible, setIsInputVisible, couponName }: SuccessProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const buttonOptions = { size: 'small', type: 'link' }
  const extraParams = { couponCode: null }
  const { cart } = useSelector<AppStore, ValorizedCartState>(({ cartStoreV2 }) => cartStoreV2.valorized)

  const handleOnClick = () => {
    // si se elimina el cupon, se  vuelve a visualizar el boton de aplicar cupon y se valoriza sin descuento.
    setIsInputVisible(!isInputVisible)
    dispatch(resetCoupon())
    dispatch(postCartValorized(cart.items, extraParams))
    dispatch(getCouponCode({ isFixed: true }))
  }

  return (
    <Container>
      <CustomIcon name="icon-bold-checkmark-circle" />
      <MessageSuccess>{t('ecommerce.coupon.success', { couponName })}</MessageSuccess>
      <CustomButton buttonoptions={buttonOptions} onClick={() => handleOnClick()}>
        {t('Eliminar')}
      </CustomButton>
    </Container>
  )
}
